/**
 * The one place the company's identity is written down.
 *
 * <p>Both legal pages read from here, so the registered address and ICO number can never disagree
 * between them — which is the sort of inconsistency that makes a notice look unserious precisely
 * where it needs to look otherwise.
 */
export const LEGAL = {
  /** Required by UK GDPR Article 13 — the notice must identify who holds the data. */
  company: 'Astrolabe Ummah Tech Ltd',
  /*
   * The next three are required by regulation 25 of the Company, Limited Liability Partnership and
   * Business (Names and Trading Disclosures) Regulations 2015 — company law, not data protection.
   * Every company must disclose its registered name, the part of the UK it is registered in, its
   * number and its registered office on its websites, in the same terms as on its letterhead.
   * A sole trader would need none of them.
   */
  companyNumber: '17429363',
  placeOfRegistration: 'England and Wales',
  /** The virtual registered office — never a home address. */
  registeredOffice: '128 City Road, London, EC1V 2NX',
  /**
   * Optional. Nothing requires publishing it; it just shows the registration is real rather than
   * asserted. Leave empty and the sentence naming it disappears.
   */
  icoRegistration: '',
  contactEmail: 'muslimmarriageeventsfinder@yahoo.com',
  siteName: 'Muslim Marriage Events',
  siteUrl: 'muslimmarriageeventsfinder.co.uk',
  lastUpdated: '26 August 2026',
} as const;
